import axiosI from '../../axios';

const putCampaignPopSeenRequest = async (campId: number | string) => {
  const response = await axiosI.put(
    `${process.env.REACT_APP_BASE_URL}/users/campaign/pop/seen?campId=${campId}`
  );
  return response.data;
};

const putCampaignPopClickRequest = async (campId: number | string) => {
  const response = await axiosI.put(
    `${process.env.REACT_APP_BASE_URL}/users/campaign/pop/click?campId=${campId}`
  );
  return response.data;
};

export { putCampaignPopClickRequest, putCampaignPopSeenRequest };
